import React, { useEffect, useRef, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumbs from '../components/Breadcrumbs';
import TopFilter from '../components/TopFilter';
import RightFilterToggle from '../components/RightFilterToggle';
import paginationFactory from 'react-bootstrap-table2-paginator';
import GridData from '../components/gridmodal/GridDataPackages';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.css';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import configData from '../configData.json';
import { format } from 'date-fns';
import Spinner from 'react-bootstrap/Spinner';
import ColumnFilter from '../components/ColumnFilter';
import { Link } from 'react-router-dom';
import GridDataPackages from '../components/gridmodal/GridDataPackages';
import MycustomDesignGrid from '../components/MycustomDesignGrid';
import { ValidDate, formatNumnberWithComma, formatAmountWithComma, formatDate, removeCommafromNumber, toLocalDate } from '../components/Utlities';

export default function TotalProcessed() {

    const [ProcessedBills, setProcessedBills] = useState([]);
    const [DetailByCustCarr, setDetailData] = useState([]);
    const [selectedSummaryRow, setSelectedRow] = useState({});
    const [lastElement, setLastElement] = useState(null);
    const [hidden, setHidden] = useState(true);
    const [fbNum, setFbNum] = useState("");
    const [acctNo, setAcctNo] = useState("");



    const [selectedCust, setSelectedCust] = useState(0);

    const { ExportCSVButton } = CSVExport;
    const { ExportCSVButtonDetail } = CSVExport;

    const [fromDate, setFromDate] = useState(undefined);
    const [toDate, setToDate] = useState(undefined);
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1);
    const [fbLoading, setFBLoading] = useState(false);
    const [prevY, setPrevY] = useState(0);

    let prevYRef = useRef({});
    let selectedRowRef = useRef({});
    let DetailByCustCarrRef = useRef({});
    let hiddenRef = useRef({});
    let pageRef = useRef({});

    prevYRef.current = prevY;
    selectedRowRef.current = selectedSummaryRow;
    DetailByCustCarrRef.current = DetailByCustCarr;
    hiddenRef.current = hidden;
    pageRef.current = page;

    const [topFilterCustKey, settopFilterCustKey] = useState(0);

    const criData = [
        { criKey: 1, criValue: 'Owner' },
        { criKey: 2, criValue: 'Customer' },
        { criKey: 3, criValue: 'Transportation Provider' },
        { criKey: 4, criValue: 'Freight Bill/Package Number' },
        { criKey: 5, criValue: 'Transportation Provider Account Number' }
    ];

    // const [sizePerPage, setSizePerPage] = useState(50);

    // const customerOnChange = (custkey) =>
    // {
    //     console.log(custkey);
    // }



    const searchOnClick = (customerKey, carrierKey, startDate, endDate, freightBillNumber, accountNumber) => {
        // debugger;
        // setSizePerPage(50);
        const fbNumber = freightBillNumber === "" ? "-1" : freightBillNumber;
        const acctNumber = accountNumber === "" ? "-1" : accountNumber;

        setFromDate(startDate);
        setToDate(endDate);
        setFbNum(freightBillNumber);
        setAcctNo(accountNumber);
        LoadSummaryData(customerKey, carrierKey, startDate, endDate, fbNumber, acctNumber);

        setSelectedCust(customerKey);
    }

    const LoadSummaryData = async (customerKey, carrierKey, startDate, endDate, freightBillNumber, accountNumber) => {
        setLoading(true);
        setProcessedBills([]);
        const URL = `${configData.BASE_APP_URL}FreightBill/GetTotalInvoiceProcessedSummary/${customerKey}/${carrierKey}/${startDate}/${endDate}/${freightBillNumber}/${accountNumber}`;
        console.log(URL);

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            if (response.ok) {
                const data = await response.json();

                // Convert various count properties to formatted strings in the response
                const modifiedResponse = data.map(item => ({
                    ...item,
                    billCount: formatNumnberWithComma(item.billCount),
                    packageCount: formatNumnberWithComma(item.packageCount),
                    characterCount: formatNumnberWithComma(item.characterCount),
                    averageCharacterCount: formatNumnberWithComma(item.averageCharacterCount),
                    pageCount: formatNumnberWithComma(item.pageCount),
                    averagePageNo: formatNumnberWithComma(item.averagePageNo),
                    captureCount: formatNumnberWithComma(item.captureCount),
                    averageCaptureCount: formatNumnberWithComma(item.averageCaptureCount),
                    populateCount: formatNumnberWithComma(item.populateCount),
                    averagePopulateCount: formatNumnberWithComma(item.averagePopulateCount),
                    // Add more properties as needed
                }));

                setProcessedBills(modifiedResponse);
            } else {
                console.error(`Error fetching data: ${response.statusText}`);
            }
        } catch (error) {
            console.error('Error during fetch:', error);
        } finally {
            setLoading(false);
        }
    };

    const LoadDetailData = async (customerKey, carrierKey, billType, setLoadingFunc, fromDetails) => {
        // debugger;
        setLoadingFunc(true);
        setDetailData([]);
        const fbNumber = fbNum === "" ? "-1" : fbNum;
        const acctNumber = acctNo === "" ? "-1" : acctNo;

        const URL = `${configData.BASE_APP_URL}FreightBill/GetTotalInvoiceProcessedDetail/${customerKey}/${carrierKey}/${billType}/${fromDate}/${toDate}/${fbNumber}/${acctNumber}`;

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            if (response.ok) {
                const data = await response.json();

                // Convert 'characterCount', 'pageCount', 'captureCount', and 'populateCount' to formatted strings in the response
                const modifiedResponse = data.map(item => ({
                    ...item,
                    characterCount: formatNumnberWithComma(item.characterCount),
                    pageCount: formatNumnberWithComma(item.pageCount),
                    captureCount: formatNumnberWithComma(item.captureCount),
                    populateCount: formatNumnberWithComma(item.populateCount),
                    // Add more properties as needed
                }));

                setDetailData(modifiedResponse);
                // OpenPopup();
                setHidden(false);
            } else {
                console.error(`Error fetching data: ${response.statusText}`);
            }
        } catch (error) {
            console.error('Error during fetch:', error);
        } finally {
            setLoadingFunc(false);
        }
    };


    const columnFormatter = (cell, row, rowIndex, formatExtraData) => {
        return (
            <div>
                <span><a href='#'><i className="fa fa-expand mr-1"></i></a>{row.customerName}</span>
            </div>
        )
    }


    const invoiceDateFormatter = (cell, row, rowIndex, formatExtraData) => {
        if (cell === "" || cell === null) {
            return <span></span>;
        }
        else {
            return (
                <span>{format(toLocalDate(cell), "MM/dd/yyyy")}</span>
            );
        }
    }

    const imageLinkFormatter = (cell, row, rowIndex, formatExtraData) => {
        return (
            <a target="_blank" href={cell}>View</a>
        )
    }

    const IsManualFormatter = (cell) => {
        return (
            cell == 'Y' ? <span>Yes</span> : <span>No</span>
        )
    }

    const columnsDetail = [
        {
            dataField: 'freightBillNumber',
            text: 'Freight Bill/Package Number',
            headerStyle: { width: '200px', textAlign: 'center' },
            align: 'left',
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />


        },
        {
            dataField: 'invoiceNumber',
            text: 'Invoice Number',
            headerStyle: { width: '180px', textAlign: 'center' },
            align: 'left',
            sort: true,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'accountNumber',
            text: 'Account Number',
            headerStyle: { width: '180px', textAlign: 'center' },
            align: 'left',
            sort: true,
        },
        {
            dataField: 'invoiceDate',
            text: 'Invoice Date',
            headerStyle: { width: '80px', textAlign: 'center' },
            align: 'left',
            sort: true,
            formatter: invoiceDateFormatter,

        },
        {
            dataField: 'billType',
            text: 'Bill Type',
            headerStyle: { width: '110px', textAlign: 'center' },
            align: 'center',
            sort: true
        },
        {
            dataField: 'characterCount',
            text: 'Number of Characters',
            headerStyle: { width: '92px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'pageCount',
            text: 'Number of Pages',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'captureCount',
            text: 'Data Fields Captured',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'populateCount',
            text: 'Data Elements Populated',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'manualBill',
            text: 'Manual Bill',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'center',
            sort: true,
            formatter: IsManualFormatter
        },
        {
            dataField: 'freightBillKey',
            text: 'Freight Bill Key',
            headerStyle: { width: '150px', textAlign: 'center' },
            align: 'left',
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'imageLink',
            text: 'Image Link',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'center',
            sort: true,
            formatter: imageLinkFormatter
        }
    ]

    let onCustomerFilter;
    let onCarrierFilter;
    const onCustomerChangeFilter = (selectedCust, selectedCarrier, selectedFromDate, selectedToDate, fbNum, acctNo) => {
        // onCustomerFilter(val);

        // if (selectedCust == 0) {
        //     alert('Customer is a Required Field, a selection must be made');
        //     return;
        // }


        setFromDate(selectedFromDate);
        setToDate(selectedToDate);
        setFbNum(fbNum);
        setAcctNo(acctNo);
        LoadSummaryData(selectedCust, selectedCarrier, selectedFromDate, selectedToDate, fbNum, acctNo);
    };
    const onCarrierChangeFilter = (val) => {
        //onCarrierFilter(val);
        console.log(val)
    };

    const columns = [
        {
            dataField: 'id',
            text: 'Id',
            headerStyle: { width: '50' },
            hidden: true,
            csvExport: false,
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'customerName',
            text: 'Customer',
            headerStyle: { width: '157px', textAlign: 'center' },
            formatter: columnFormatter,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    setPage(1);
                    const selectedRow = {
                        customerKey: row.customerKey,
                        customerName: row.customerName,
                        carrierKey: row.carrierKey,
                        carrierName: row.carrierName,
                        billType: row.billType,
                        totalBills: row.billCount,
                        totalPackages: row.packageCount
                    }
                    setSelectedRow(selectedRow);
                    LoadDetailData(row.customerKey, row.carrierKey, row.billType, setLoading, false);
                }
            },
            filter: customFilter(),
            filterRenderer: (onFilter, column) => {
                onCustomerFilter = onFilter;
                <ColumnFilter onFilter={onFilter} column={column} />
            }
            // filterRenderer: (onFilter, column) =>
            //     <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'carrierName',
            text: 'Transportation Provider',
            headerStyle: { width: '300px', textAlign: 'center' },
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'billType',
            text: 'Bill Type',
            headerStyle: { width: '110px', textAlign: 'center' },
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'billCount',
            text: 'Total Number of Bills',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'packageCount',
            text: 'Total Number of Packages',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'characterCount',
            text: 'Total Number of Characters',
            headerStyle: { width: '100px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'averageCharacterCount',
            text: 'Average Number of Characters',
            headerStyle: { width: '120px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'pageCount',
            text: 'Total Number of Pages',
            headerStyle: { width: '110px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'averagePageNo',
            text: 'Average Number of Pages',
            headerStyle: { width: '130px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'captureCount',
            text: 'Total Number of Data Fields Captured',
            headerStyle: { width: '130px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'averageCaptureCount',
            text: 'Average Number of Data Fields Captured ',
            headerStyle: { width: '150px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
        {
            dataField: 'populateCount',
            text: 'Total Number of Data Fields Populated',
            headerStyle: { width: '130px', textAlign: 'center' },
            align: 'right',
            sort: true,
        },
        {
            dataField: 'averagePopulateCount',
            text: 'Average Number of Data Fields Populated  ',
            headerStyle: { width: '150px', textAlign: 'center' },
            align: 'right',
            sort: true
        },
    ];

    const observer = useRef(
        new IntersectionObserver((entries, pagingOptioins) => {
            // debugger
            const first = entries[0];
            if (first.isIntersecting) {
                setPage((no) => no + 1);
            }
        })
    );

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        // debugger;
        // setSizePerPage(50);
        if (selectedSummaryRow.customerKey) {
            LoadDetailData(selectedSummaryRow.customerKey, selectedSummaryRow.carrierKey, selectedSummaryRow.billType, setFBLoading, true)
        }
    }, [pageRef.current])

    useEffect(() => {
        // debugger;
        // setSizePerPage(50);
        const currentElement = lastElement;
        const currentObserver = observer.current;

        if (currentElement) {
            currentObserver.observe(currentElement);
        }

        return () => {
            if (currentElement) {
                currentObserver.unobserve(currentElement);
            }
        };
    }, [lastElement]);


    const sizePerPageRenderer = ({
        options,
        currSizePerPage,
        onSizePerPageChange
    }) => (
        <div className="btn-group" role="group">
            {
                options.map((option) => {
                    // debugger;
                    const isSelect = currSizePerPage === `${option.page}`;
                    return (
                        <button
                            key={option.text}
                            type="button"
                            onClick={() => onSizePerPageChange(option.page)}
                            className={`btn ${isSelect ? 'btn-secondary' : 'btn-warning'}`}
                        >
                            {option.text}
                        </button>
                    );
                })
            }
        </div>
    );

    const options = {
        // pageStartIndex: 1,
        // paginationSize: 50,,
        // sizePerPage : 50,

        // sizePerPage: 50,
        sizePerPageRenderer,
        sizePerPageList: [
            {
                text: '50', value: 50
            }, {
                text: '100', value: 100
            },
            {
                text: '200', value: 200
            },
            {
                text: 'All', value: ProcessedBills.length
            }
        ]

    };


    const detailOptions = {
        // pageStartIndex: 1,
        // paginationSize: 50,,
        // sizePerPage : 50,
        sizePerPageRenderer,
        sizePerPageList: [
            {
                text: '50', value: 50
            }, {
                text: '100', value: 100
            },
            {
                text: '200', value: 200
            },
            {
                text: 'All', value: DetailByCustCarr.length
            }
        ]


    };

    const CloseModal = () => {
        setHidden(!hidden);
    }

    const DownloadSummaryData = async () => {
        debugger;
        const URL = `${configData.BASE_APP_URL}FreightBill/GenerateExcelTotalInvoiceProcessedSummary`;
        // console.log(URL);

        const modifiedResponse = ProcessedBills.map(item => ({
            ...item,
            billCount: removeCommafromNumber(item.billCount),
            packageCount: removeCommafromNumber(item.packageCount),
            characterCount: removeCommafromNumber(item.characterCount),
            averageCharacterCount: removeCommafromNumber(item.averageCharacterCount),
            pageCount: removeCommafromNumber(item.pageCount),
            averagePageNo: removeCommafromNumber(item.averagePageNo),
            captureCount: removeCommafromNumber(item.captureCount),
            averageCaptureCount: removeCommafromNumber(item.averageCaptureCount),
            populateCount: removeCommafromNumber(item.populateCount),
            averagePopulateCount: removeCommafromNumber(item.averagePopulateCount),
            // Add more properties as needed
        }));


        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            },
            body: JSON.stringify({ data: modifiedResponse }),
            responseType: 'blob'
        });

        const data = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = `Total Invoice Processed Summary.xlsx`;
        link.click();

    };

    const DownloadDetailData = async () => {
        debugger;
        const URL = `${configData.BASE_APP_URL}FreightBill/GenerateExcelTotalInvoiceProcessedDetail`;
        // console.log(URL);

        const modifiedResponse = DetailByCustCarr.map(item => ({
            ...item,
            characterCount: removeCommafromNumber(item.characterCount),
            pageCount: removeCommafromNumber(item.pageCount),
            captureCount: removeCommafromNumber(item.captureCount),
            populateCount: removeCommafromNumber(item.populateCount),
            // Add more properties as needed
        }));


        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            },
            body: JSON.stringify({ data: modifiedResponse }),
            responseType: 'blob'
        });

        const data = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = `Total Invoice Processed Detail.xlsx`;
        link.click();

    };


    const breadcumTitle = <div dangerouslySetInnerHTML={{ __html: 'Total Invoice Processed <span class="breadcumspan">(Total Number of Bills Processed by Customer/Provider)</span>' }} />;

    return (

        <div className='pt-1 px-3 pb-3 py-3'>
            <div className='floating-table-overlay' hidden={hidden}></div>
            <div hidden={hidden} className="floating-table shadow-sm full-height-modal">
                <div className='row g-0 p-2 bg-white'>
                    {/* <button onClick={() => setHidden(!hidden)} className='close-modal'><i className="fas fa-times"></i></button> */}
                    <button onClick={CloseModal} className='close-modal'><i className="fas fa-times"></i></button>
                    <GridDataPackages data={selectedRowRef.current} />
                </div>
                <div className='border-top p-2 table-container'>
                    <div className='custom-table-text'>
                        {DetailByCustCarr.length > 0 ?
                            <ToolkitProvider
                                keyField="freightBillKey"
                                data={DetailByCustCarr}
                                columns={columnsDetail}
                                exportCSV={{ fileName: 'Total Invoice Processed Detail.csv' }}>
                                {
                                    props => (
                                        <div>
                                            <BootstrapTable
                                                classes='table table-striped table-hover table-width-small'
                                                headerClasses='table-top'
                                                bootstrap4
                                                keyField='freightBillKey'
                                                data={DetailByCustCarrRef.current}
                                                columns={columnsDetail}
                                                pagination={paginationFactory(detailOptions)}
                                                {...props.baseProps}
                                                filter={filterFactory()}

                                            />
                                            <button className='btn react-bs-table-csv-btn' onClick={DownloadDetailData}><i className='fa fa-download'></i> Export
                                            </button>
                                            {/* <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i>Export</ExportCSVButton> */}
                                        </div>
                                    )
                                }
                            </ToolkitProvider> : <>
                                <MycustomDesignGrid column={columnsDetail} />
                            </>}
                        <div style={{ minHeight: "10px", margin: "20px" }}>
                            {/* <span style={{ display: fbLoading ? "block" : "none" }}>Loading...</span> */}
                            {fbLoading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : fbLoading}
                        </div>
                    </div>
                </div>
            </div>

            {/* <Breadcrumbs title={"Total Invoice Processed"<span>(Total Number of Bills Processed by Customer/Provider)</span> } /> */}
            <Breadcrumbs title={breadcumTitle} />
            {loading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : loading}
            <div className='sticky-top-content'>
                <TopFilter oncustom={onCustomerChangeFilter} oncustom1={onCarrierChangeFilter} criData={criData} />
            </div>
            <div className='d-flex'>
                <div className="table-container">
                    <div className='grid-toggle'>
                        <div className='main-table-text dropup'>
                            {/* <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: "right" }}><button className='btn react-bs-table-csv-btn' onClick={OpenDownloadPopUp}><i className='fa fa-download'></i> Export</button></div> */}
                            {ProcessedBills.length > 0 ?
                                <ToolkitProvider
                                    keyField="id"
                                    data={ProcessedBills}
                                    columns={columns}
                                    exportCSV={{ fileName: 'Total Invoice Processed Summary.csv' }}>
                                    {
                                        props => (
                                            <div>
                                                {/* <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i> Export</ExportCSVButton> */}
                                                <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: "right" }}>
                                                    <button className='btn react-bs-table-csv-btn' onClick={DownloadSummaryData}><i className='fa fa-download'></i> Export
                                                    </button>
                                                </div>
                                                <BootstrapTable
                                                    classes='table table-striped table-hover table-width'
                                                    headerClasses='table-top'
                                                    bootstrap4
                                                    pagination={paginationFactory(options)}
                                                    {...props.baseProps}
                                                    filter={filterFactory()}
                                                />
                                                {/* <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i> Export</ExportCSVButton> */}
                                            </div>
                                        )
                                    }
                                </ToolkitProvider> : <>
                                    <MycustomDesignGrid column={columns} />
                                </>}
                        </div>
                    </div>
                </div>
                <RightFilterToggle onSearchClick={searchOnClick} />
            </div>
        </div>
    )
}